<template>
  
  <div class="myDatesBarDiv">


      <div v-for="(oneDate, index) in myDates" :key="index" class="px-2 h-14">

        <div :class="{'bg-red-200': selectedIndex == index , 'bg-white': selectedIndex != index}" :key="selectedIndex">
            
            <my-dates-bar-component :myDate="oneDate" :index="index" :selectIndex="selectIndex"/>
        </div>

        <div v-show="selectedIndex == index" class="-mt-1 fill-current text-red-600">

            <font-awesome-icon icon="arrow-up" size="sm"/>
        </div>          
      </div>
  </div>
</template>

<script>

import myDatesBarComponent from './MyDatesBarComponent'
export default {

    mounted(){

        // console.log(`myDates: ${JSON.stringify(this.myDates)}`)

            this.setLastSelectedIndex();
    },

    props:{

        lastSelectedIndex: 0,

        myDates: {

            type: Array
        },

        todayDate: '',

        setDate: {

            type: Function
        },

        useWithPanel: false,

        fromPage: true,
    },

    components:{

        myDatesBarComponent  
    },

    methods:{

        setLastSelectedIndex(){

            // console.log(`this.lastSelectedIndex: ${this.lastSelectedIndex}`);
            // console.log(`this.myDates[this.lastSelectedIndex]: ${JSON.stringify(this.myDates[this.lastSelectedIndex])}`);

            if(this.lastSelectedIndex != 0 && this.fromPage == true){

                this.selectedIndex = this.lastSelectedIndex;

                // console.log(`this.myDates[this.lastSelectedIndex].date: ${JSON.stringify(this.myDates[this.lastSelectedIndex]["date"])}`);

                this.setDate(this.myDates[this.lastSelectedIndex]["date"]);
            }
        },

        changeDate(value){ 


            if(value){

            // console.log(`isNext: true`)

                this.selectedIndex = this.selectedIndex + 1;

            }else{

            // console.log(`isNext: false`)

                this.selectedIndex = this.selectedIndex - 1;
            }
            // console.log(`changeDate`);
        },

        selectIndex(myDate, index){

            // console.log(`myDate: ${JSON.stringify(myDate)}`);
            this.selectedIndex = index;
            // console.log(`selectedIndex: ${this.selectedIndex}`);

            if(this.useWithPanel){

                this.setDate(myDate.date);
            }
        }
    },

    data: function(){

        return{

            selectedIndex: 0,
        }
    }

}
</script>

<style>

</style>